
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../../lib/supabase';

const DangerZoneSection = () => {
  const [showSignOutConfirm, setShowSignOutConfirm] = useState(false);
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      const { error } = await supabase.auth.signOut();
      if (error) {
        // Optionally display the error to the user or log it
        console.error('Sign‑out error:', error);
        return;
      }
      navigate('/');
    } catch (err) {
      // Unexpected errors (network, etc.)
      console.error('Unexpected sign‑out error:', err);
    }
  };

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-6 md:p-8">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-8 h-8 flex items-center justify-center">
          <i className="ri-shield-line text-xl text-[#f04e58]"></i>
        </div>
        <h2 className="text-lg font-semibold text-gray-900">Account</h2>
      </div>

      <div className="space-y-4">
        {/* Sign Out */}
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 p-4 rounded-lg bg-gray-50">
          <div>
            <p className="text-sm font-medium text-gray-900">Sign Out</p>
            <p className="text-xs text-gray-500 mt-0.5">
              Sign out of your account on this device
            </p>
          </div>
          {!showSignOutConfirm ? (
            <button
              type="button"
              onClick={() => setShowSignOutConfirm(true)}
              className="inline-flex items-center gap-2 px-5 py-2 border border-gray-300 text-gray-700 text-sm font-medium rounded-lg hover:bg-gray-100 transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-logout-box-line"></i>
              Sign Out
            </button>
          ) : (
            <div className="flex items-center gap-2">
              <button
                type="button"
                onClick={() => setShowSignOutConfirm(false)}
                className="px-4 py-2 text-sm text-gray-600 hover:text-gray-900 cursor-pointer whitespace-nowrap"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleSignOut}
                className="inline-flex items-center gap-2 px-5 py-2 bg-red-500 text-white text-sm font-medium rounded-lg hover:bg-red-600 transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-logout-box-line"></i>
                Confirm Sign Out
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DangerZoneSection;
